// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles-module--badge--ZZ6PG","fadeIn":"styles-module--fadeIn--2yOs1","pulse":"styles-module--pulse--3cZ0t","slideInDown":"styles-module--slideInDown--3GfRB"};